export const CONDITION_TYPE = {
  ENTITY: 'entity_condition',
  REGEXP: 'regexp_condition',
  FEATURE: 'entity_feature_condition',
};

export const CONDITION_TYPE_MAP = {
  entity_condition: 'entity',
  regexp_condition: 'regex',
  entity_feature_condition: 'feature',
};

export const ACTION_TYPE = {
  MARK: 'mark_action',
  UNMARK: 'unmark_action',
  SHIFT: 'shift_action',
  FILL: 'fill_action',
};

export const FEATURE_TYPE = {
  STRING: 'String',
  BOOLEAN: 'Boolean',
};

export const FEATURE_VALUE_TYPE = {
  EXPLICIT: 'explicit',
  DYNAMIC: 'dynamic',
  CONCATENATION: 'concatenation',
  COVER_TEXT: 'coverText',
};

export const TABS = [
  { label: 'General', tabIndex: 1, hasWarning: false },
  { label: 'Matching Pattern', tabIndex: 2, hasWarning: false },
  { label: 'Conditions', tabIndex: 3, hasWarning: false },
  { label: 'Actions', tabIndex: 4, hasWarning: false },
  { label: 'Context', tabIndex: 5, hasWarning: false },
];
